import React from 'react';
import ConfigureLayout from '../../components/configure/ConfigureLayout';
import MessagesSoundsContainer from '../../components/configure/messagesSounds/MessagesSounds';
const MessagesSounds = () => {
  return (
    <ConfigureLayout>
      <MessagesSoundsContainer />
    </ConfigureLayout>
  );
};

export default MessagesSounds;
